// extracted by mini-css-extract-plugin
export var slide = "SlideWide-module--slide--117e3";
export var wrapper = "SlideWide-module--wrapper--c2f9d";
export var nameWrapper = "SlideWide-module--nameWrapper--5c295";
export var picture = "SlideWide-module--picture--70d6f";
export var img = "SlideWide-module--img--bb32b";
export var text = "SlideWide-module--text--4e846";
export var link = "SlideWide-module--link--88d9c";
export var linkText = "SlideWide-module--linkText--7c40d";
export var icon = "SlideWide-module--icon--166fc";
export var position = "SlideWide-module--position--20545";
export var description = "SlideWide-module--description--ed759";